/*
 * @Author: Ashley.Liu
 * @Date: 2022-07-13 18:32:38
 * @LastEditTime: 2022-08-15 17:22:58
 * @Description: desc
 */
import Vue from 'vue'
import Vuex from 'vuex'
import globalinfo from './modules/globalinfo'
import rest from './modules/rest'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    permissions: JSON.parse(localStorage.getItem('permissions') || '[]')
  },
  getters: {
    permissions: state => state.permissions,
    clusters: state => state.globalinfo.clusters,
    allClusters: state => state.globalinfo.allClusters,
    businessNames: state => state.globalinfo.businessNames,
    clusterTree: state => state.globalinfo.clusterTree,
    commandHistories: state => state.rest.commandHistories,
    tenants: state => state.globalinfo.tenants,
    myTenants: state => state.globalinfo.myTenants,
    roles: state => state.globalinfo.roles,
    businessGroups: state => state.globalinfo.businessGroups
  },
  mutations: {
    setPermissions(state, permissions) {
      if (typeof permissions === 'string') {
        state.permissions = JSON.parse(permissions)
        localStorage.setItem('permissions', permissions)
      } else {
        state.permissions = permissions
        localStorage.setItem('permissions', JSON.stringify(permissions))
      }
    }
  },
  actions: {
    setPermissions({ commit }, permissions) {
      commit('setPermissions', permissions)
    }
  },
  modules: {
    globalinfo,
    rest
  }
})

export default store
